import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
// import { email } from '@config';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, my name is</h1>;
  const two = <h2 className="big-heading">Kelvin Muriuki.</h2>;
  const three = <h3 className="big-heading"> I specialize in Data Science, Full-stack Web Development, and building scalable solutions.</h3>;
  const four = (
    <>
      <p>
        Results-driven and forward-thinking Data Scientist and Full-stack Developer with extensive 
experience in statistical analysis, machine learning, and full-stack web development. A strategic 
thinker who thrives on transforming complex data into actionable insights to drive business growth 
and innovation. Highly skilled in applying predictive analytics, statistical modeling, and advanced 
algorithms to solve real-world problems across multiple industries, including finance, e-commerce, 
and public sector. 
With a proven ability to build data-driven applications and optimize processes, I leverage a 
combination of cutting-edge technologies and agile methodologies to deliver scalable and efficient 
solutions. My expertise spans across data visualization, big data analytics, and cloud computing, 
empowering organizations to unlock the full potential of their data. 
Recognized for leadership in executing transformative projects, I excel in collaborative environments, 
consistently exceeding performance metrics and contributing to strategic decision-making. Driven by 
a passion for continuous learning and innovation, I am eager to work on impactful, data-centric 
challenges that drive the future of technology and business. 
      </p>
    </>
  );
  const five = (
    <a
      className="email-link"
      href="mailto:muriukikelvin27@gmail.com"
      target="_blank"
      rel="noreferrer"
    >
      Contact me
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
